import React from 'react'
import styled from "styled-components"

import Layout from "../components/layout"
import SEO from "../components/seo"

const ScreenWrap = styled.div`
  height:100vh;
  iframe {
    border:0;
  }
`

class GameScreen extends React.Component {

  render() {
    return (
      <Layout style={{ backgroundColor: 'black' }}>
        <SEO title="Ouroboros Game" keywords={[`IOHK`, `Cardano`, `Ouroboros`, `Game`]} />
        <ScreenWrap>
          <iframe title='ouroboros visualizer' src=" https://input-output-hk.github.io/ouroboros-visualizer/" width="100%" height="100%" border="0"></iframe>
        </ScreenWrap>
      </Layout>
    )
  }
}

export default GameScreen;
